var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wt-asset-editor-view js-modal-content",class:_vm.classObj,style:(_vm.styleObj)},[_c(_vm.currentPageComponent,{tag:"component"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }